import { render, staticRenderFns } from "./pieChart2.vue?vue&type=template&id=8f8aac86&scoped=true"
import script from "./pieChart2.vue?vue&type=script&lang=js"
export * from "./pieChart2.vue?vue&type=script&lang=js"
import style0 from "./pieChart2.vue?vue&type=style&index=0&id=8f8aac86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f8aac86",
  null
  
)

export default component.exports